export default "__VITE_ASSET__Cs3AK8uW__"